export default "__VITE_ASSET__whNf79w0__"